import { useState, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import Homepage from './Pages/Homepage';
import Navbar from './components/common/Navbar';
import Footer from './components/common/Footer';
import Gallarynav from './components/common/Gallarynav';
import ContactPage from './components/core/Contact/ContactPage';
import AboutUs from './Pages/AboutUs';
import LoginForm from './components/common/auth/LoginForm';
import ForgotPassword from './components/common/auth/ForgotPassword';
import UpdatePassword from './components/common/auth/UpdatePassword';
import Dashboad from './components/common/auth/Dashboad';
import ScrollToTop from './components/ScrollToTop';
import ManageCategory from './components/common/auth/MAincon/ManageCategory';
import CatalogCard from './components/common/CatalogCard';
import './styles/fonts.css';
import { FaWhatsapp, FaEnvelope, FaArrowCircleUp } from 'react-icons/fa';

function App() {
  // State to track whether to show the scroll-to-top button
  const [showScrollButton, setShowScrollButton] = useState(false);

  // Handle scroll event
  const handleScroll = () => {
    if (window.scrollY > 200) {
      setShowScrollButton(true); // Show button if scrolled down more than 200px
    } else {
      setShowScrollButton(false); // Hide button if not
    }
  };

  // Attach scroll event listener
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll); // Clean up the event listener
    };
  }, []);

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div className="">
      <Navbar />
      <ScrollToTop />
      <Routes>
        <Route path="/login" element={<LoginForm />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/update-password/:id" element={<UpdatePassword />} />
        <Route path="/dashboard/profile" element={<Dashboad />} />
        <Route path="/dashboard/category" element={<ManageCategory />} />
        <Route path="/" element={<Homepage />} />
        <Route path="/gallery" element={<Gallarynav />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/catalog/:categoryId" element={<CatalogCard />} />
      </Routes>
      <Footer />

      {/* Floating icons */}
      <div className="fixed bottom-4 left-4 flex flex-col items-center z-50">
        {/* WhatsApp Icon */}
        <a
          href="https://wa.me/7303572367"
          target="_blank"
          rel="noopener noreferrer"
          className="p-1 rounded-full transition transform hover:scale-110"
        >
          <FaWhatsapp className="text-white text-4xl bg-[#0ABE3D] rounded-full p-1 transition-all transform hover:scale-125" />
        </a>
{/* this is onluy sdsfdjhdfvjdfshfsdjjfd
dx */}
        {/* Gmail Icon */}
        <a
          href="https://mail.google.com/mail/?view=cm&fs=1&to=sumitkumar1998aug@gmail.com"
          className="p-1 rounded-full transition transform hover:scale-110"
        >
          <FaEnvelope className="text-white text-4xl bg-blue-200 rounded-xl p-1 transition-all transform hover:scale-125" />
        </a>
      </div>

      {/* Scroll to top icon, shown only when scrolled down */}
      {showScrollButton && (
        <div
          className="fixed bottom-4 right-4 z-50 cursor-pointer"
          onClick={scrollToTop}
        >
          <FaArrowCircleUp className="text-white text-5xl bg-yellow-500 rounded-full p-3 transition-all transform hover:scale-110" />
        </div>
      )}
    </div>
  );
}

export default App;
